/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoGroupRoleCategoryListRequest model module.
 * @module model/SystemControllerDtoGroupRoleCategoryListRequest
 * @version 1.0
 */
class SystemControllerDtoGroupRoleCategoryListRequest {
    /**
     * Constructs a new <code>SystemControllerDtoGroupRoleCategoryListRequest</code>.
     * @alias module:model/SystemControllerDtoGroupRoleCategoryListRequest
     */
    constructor() { 
        
        SystemControllerDtoGroupRoleCategoryListRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>SystemControllerDtoGroupRoleCategoryListRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoGroupRoleCategoryListRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoGroupRoleCategoryListRequest} The populated <code>SystemControllerDtoGroupRoleCategoryListRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoGroupRoleCategoryListRequest();

            if (data.hasOwnProperty('groupNo')) {
                obj['groupNo'] = ApiClient.convertToType(data['groupNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoGroupRoleCategoryListRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoGroupRoleCategoryListRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} groupNo
 */
SystemControllerDtoGroupRoleCategoryListRequest.prototype['groupNo'] = undefined;






export default SystemControllerDtoGroupRoleCategoryListRequest;

